import React from 'react';
import HeaderWidgetOptions from './HeaderWidgetOptions';
import MediaWidgetOptions from './MediaWidgetOptions';
import ButtonWidgetOptions from './ButtonWidgetOptions';
import TextWidgetOptions from './TextWidgetOptions';
import SocialWidgetOptions from './SocialWidgetOptions';
import AgendaWidgetOptions from './AgendaWidgetOptions';
import ChecklistWidgetOptions from './ChecklistWidgetOptions';
import IncludeHeadersOption from './IncludeHeadersOption';
import IconWidgetOptions from './IconWidgetOptions';
import DividerWidgetOptions from './DividerWidgetOptions';
import CountdownWidgetOptions from './CountdownWidgetOptions';

// Conventions:
// - Single-item widgets should use WidgetOptionsForm for the shared auto-apply form contract.
// - Repeated-item widgets should pair WidgetOptionsForm with repeatedWidgetItems helpers.
const WidgetUpdateOptions = props => {
	const { type } = props;

	switch (type) {
		case 'Media':
			return <MediaWidgetOptions {...props} />;
		case 'Button':
			return <ButtonWidgetOptions {...props} />;
		case 'Header':
			return <HeaderWidgetOptions {...props} />;
		case 'Text':
			return <TextWidgetOptions {...props} />;
		case 'Icon':
			return <IconWidgetOptions {...props} />;
		case 'Divider':
			return <DividerWidgetOptions {...props} />;
		case 'Social Feed':
			return <SocialWidgetOptions {...props} />;
		case 'Agenda':
			return <AgendaWidgetOptions {...props} />;
		case 'Countdown':
			return <CountdownWidgetOptions {...props} />;
		case 'Checklist':
			return <ChecklistWidgetOptions {...props} />;
		default:
			return <IncludeHeadersOption {...props} />;
	}
};

export default WidgetUpdateOptions;
